<script setup lang="ts">
import { AppPermissions } from "@/shared/permissions"
import { type MenuOption, NButton, NDrawer, NDrawerContent, NIcon, NMenu } from "naive-ui"
import { useRoute, useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import { PlusCircleIcon } from "@/components/icons"
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core/index"
import { useAuthStore } from "@/store/authStore.ts"
import { CampaignRouteNameEnum } from "@/shared/enums/routes/campaign.enum.ts"
import { ScreenRouteNameEnum } from "@/shared/enums/routes/screen.enum.ts"

type customOption = MenuOption & { description?: string; type?: string };

const { t } = useI18n()
const breakpoints = useBreakpoints(breakpointsTailwind)

const greaterXl = breakpoints.greater("xl")

const authStore = useAuthStore()

defineProps<{
	show: boolean,
	menuOptions: customOption[]
}>()
const emit = defineEmits<{
	(e: "update:show", show: boolean): void
}>()

const route = useRoute()
const router = useRouter()

const menuUpdated = (key: string, item: MenuOption) => {
	emit("update:show", false)
	if (route.name === key) return
	router.push({ name: key })

}

const addNewCampaign = () => {
	router.push({ name: CampaignRouteNameEnum.locations })
	emit("update:show", false)
}
const addNewScreen = () => {
	router.push({ name: ScreenRouteNameEnum.list, query: { a: "addScreen" } })
	emit("update:show", false)
}
const addNewLocation = () => {
	router.push({ name: ScreenRouteNameEnum.create })
	emit("update:show", false)
}
</script>

<template>
	<n-drawer :show="show" @update:show="val=> $emit('update:show', val)" :width="400">
		<n-drawer-content closable>
			<n-menu
				@update:value="menuUpdated"
				:value="String(route.name)"
				:options="menuOptions" />


			<template #footer>
				<div class="header_campaign" >
					<n-button
						v-if="authStore.can({ any: ['campaign.create', 'campaign.create.for-subordinate'] })"
						@click="addNewCampaign"
						class="secondary-button">
						<template #icon>
							<n-icon>
								<PlusCircleIcon />
							</n-icon>
						</template>
						{{ greaterXl ? t("layouts.sidemenu.add_new_campaign") : t("layouts.sidemenu.campaign") }}
					</n-button>
					<n-button
						v-if="authStore.can(AppPermissions.CanCreateScreen) && route.name !== ScreenRouteNameEnum.list"
						@click="addNewScreen"
						class="secondary-button">
						<template #icon>
							<n-icon>
								<PlusCircleIcon />
							</n-icon>
						</template>
						{{ greaterXl ? t("layouts.sidemenu.add_new_screen") : t("layouts.sidemenu.screen") }}
					</n-button>
					<n-button
						v-if="
						authStore.can(AppPermissions.CanCreatePlace) &&
						route.name !== ScreenRouteNameEnum.list &&
						route.name !== ScreenRouteNameEnum.create
					"
						@click="addNewLocation"
						class="secondary-button">
						<template #icon>
							<n-icon>
								<PlusCircleIcon />
							</n-icon>
						</template>
						{{ greaterXl ? t("layouts.sidemenu.add_new_location") : t("layouts.sidemenu.location") }}
					</n-button>
				</div>
			</template>
		</n-drawer-content>
	</n-drawer>
</template>

<style scoped lang="scss">
:deep(.n-drawer-body-content-wrapper) {
	padding: 0;
}
</style>